import { useQuery } from '@tanstack/react-query';
import { api } from '../client';
import { queryKeys } from '../query-keys';

export function useUserMarketsSelect(username: string | undefined) {
  return useQuery({
    queryKey: queryKeys.userMarkets.byUsername(username),
    enabled: !!username,
    queryFn: async () => {
      const res = await api.userMarketsApi.apiUserMarketsUsernameGet(username!);
      return res.data;
    },
    meta: {
      skipGlobalError: false,
    },
  });
}
